import React, { useEffect, useState } from 'react';
import { styled } from '@compiled/react';
import RefreshIcon from '@atlaskit/icon/glyph/refresh';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { formatDistanceStrictWithLocale } from '@atlassian/jira-platform-utils-date-fns';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import messages from './messages';
import { TimeAgoLabel } from './styled';

type LastRefreshedProps = {
	lastRefreshed: number;
	updateInterval: number;
};

export const LastRefreshed = ({ lastRefreshed, updateInterval }: LastRefreshedProps) => {
	const [lastRefreshedTimeAgo, setLastRefreshedTimeAgo] = useState<string>('');
	const { formatMessage } = useIntl();
	const { locale } = useTenantContext();

	useEffect(() => {
		setLastRefreshedTimeAgo(formatMessage(messages.justNow));
		const refreshInterval = setInterval(
			() =>
				lastRefreshed != null &&
				setLastRefreshedTimeAgo(
					formatMessage(messages.timeAgo, {
						timeAgo: formatDistanceStrictWithLocale(lastRefreshed, new Date(), locale),
					}),
				),
			updateInterval,
		);
		return () => clearInterval(refreshInterval);
	}, [formatMessage, lastRefreshed, locale, updateInterval]);

	return (
		<LastRefreshedWrapper>
			<RefreshIcon size="small" label={formatMessage(messages.lastRefreshedIcon)} />
			<TimeAgoLabel>{lastRefreshedTimeAgo}</TimeAgoLabel>
		</LastRefreshedWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LastRefreshedWrapper = styled.div({
	display: 'flex',
	paddingTop: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest', colors.N200),
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '13px',
	flexDirection: 'row',
	clear: 'both',
});
